const router = {
    path: 'seedling',
    name: 'seedling',
    component: resolve => require(['../../views/seedling/index.vue'], resolve),
    meta: {
        requireAuth: true,
        keepAlive: false,
        title: '苗木管理',
        level: 1
    },
    children: [
      {
        path: 'stock',
        name: 'stock',
        meta: {
          requireAuth: true,
          title: '库存查询',
          level: 2,
          keepAlive: false,
        },
        component: resolve => require(['../../views/seedling/stock/index.vue'], resolve)
      },
      {
        path: 'pandian',
        name: 'pandian',
        meta: {
          requireAuth: true,
          title: '定时盘点',
          level: 2,
          keepAlive: false,
        },
        component: resolve => require(['../../views/seedling/pandian/index.vue'], resolve)
      },
      {
        path: 'adv',
        name: 'adv',
        meta: {
          requireAuth: true,
          title: '营销推广',
          level: 2,
          keepAlive: false,
        },
        component: resolve => require(['../../views/seedling/adv/index.vue'], resolve)
      },
      {
        path: 'warehouse',
        name: 'warehouse',
        meta: {
          requireAuth: true,
          title: '苗圃管理',
          level: 2,
          keepAlive: false,
        },
        component: resolve => require(['../../views/seedling/warehouse/index.vue'], resolve)
      },
    ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/module/seedling.js